import { CallHistoryMethodAction, push } from "connected-react-router";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { inject, injectable } from "inversify";
import { EnvVariable } from "Models/EnvVariable";
import { Dispatch } from "react";
import Types from "ServiceProvider/Types";
import { EnvConfigUtils } from "Utils/EnvConfigUtils";
import { ILoginController } from "../../Interfaces/Controllers/ILoginController";
import { ActionTypes, ILogoutAction, IUpdateTokenAction } from "./AuthenticationActionTypes";

export interface IAuthenticationAction {
    login(): any;
    updateTokenAsync(token: string, companyId: number, route: string): any;
    logout(): any;
}

@injectable()
export class AuthenticationAction implements IAuthenticationAction {
    private userInfoController: ILoginController;
    private readonly envConfigUtils: EnvConfigUtils;

    public constructor(
        @inject(Types.IUserInfoController) userInfoController: ILoginController,
        @inject(Types.IEnvConfigUtils) envConfigUtils: IEnvConfigUtils) {
        this.userInfoController = userInfoController;
        this.envConfigUtils = envConfigUtils;
    }

    public login() {
        const envVariable: EnvVariable = this.envConfigUtils.getEnvVariables();
        window.location.href = `${envVariable.cmsUrl}/login?portal=/tasks`;
    }

    public updateTokenAsync(token: string, companyId: number, route?: string) {
        return async (dispatch: Dispatch<IUpdateTokenAction | CallHistoryMethodAction>) => {
            try {
                const login = await this.userInfoController.getLoginAsync(token, companyId);

                dispatch({
                    type: ActionTypes.UPDATE_TOKEN,
                    data: login
                });

                dispatch(push(route || "/"));
            }
            catch (ex) {
                this.login();
            }
        };
    }

    public logout() {
        return (dispatch: Dispatch<ILogoutAction>) => {
            dispatch({
                type: ActionTypes.LOGOUT
            });
        };
    }
}


// WEBPACK FOOTER //
// ./src/Store/Authentication/AuthenticationAction.ts